export default __webpack_public_path__ + "static/nav-robot-921229d40ed101b551a293bb4fc23f69.ico";